import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";

import { QuestionnairePreview } from "../../../QuestionnairePreview";

export interface CampaignInquiryQuestionnaireProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const CampaignInquiryQuestionnaire = ({ campaignInquiry }: CampaignInquiryQuestionnaireProps) => {
    return <QuestionnairePreview questionnaire={campaignInquiry?.questionnaire} />;
};
